// extracted by mini-css-extract-plugin
var _1 = "T_xhJpRe";
var _2 = "T_xhJpRe";
var _3 = "WVKteVV2";
var _4 = "ZnUdzKQc";
var _5 = "ZnUdzKQc";
export { _1 as "auto-fit", _2 as "autoFit", _3 as "list", _4 as "single-column", _5 as "singleColumn" }
